import type { ReactNode } from "react"
import {
  CalendarOutlined,
  BellOutlined,
  FileTextOutlined,
  TeamOutlined,
  AppstoreOutlined,
} from "@ant-design/icons"
import { Resource, Action } from "@mimber/schema"

export const RESOURCE_LABELS: Partial<Record<Resource, string>> = {
  [Resource.EVENT]: "Event",
  [Resource.ANNOUNCEMENT]: "Announcement",
  [Resource.INVOICE]: "Invoice",
  [Resource.MEMBERSHIP]: "Membership",
}

export const ACTION_LABELS: Partial<Record<Action, string>> = {
  [Action.CREATE]: "Created",
  [Action.UPDATE]: "Updated",
  [Action.DELETE]: "Deleted",
}

export const ACTION_COLORS: Partial<Record<Action, string>> = {
  [Action.CREATE]: "green",
  [Action.UPDATE]: "orange",
  [Action.DELETE]: "red",
}

const RESOURCE_ICON_MAP: Partial<Record<Resource, ReactNode>> = {
  [Resource.EVENT]: <CalendarOutlined />,
  [Resource.ANNOUNCEMENT]: <BellOutlined />,
  [Resource.INVOICE]: <FileTextOutlined />,
  [Resource.MEMBERSHIP]: <TeamOutlined />,
}

export const getActivityIcon = (resource: Resource): ReactNode =>
  RESOURCE_ICON_MAP[resource] ?? <AppstoreOutlined />
